import React from 'react';
import useAppContext from 'flow/hooks/useAppContext';
interface EmptyStateItemProp {
    text: string;
}

const EmptyState: Record<string, EmptyStateItemProp> = {
    FavoritePbx: { text: 'central_switch.favorite_pbx.empty' },
    FavoriteContacts: {
        text: 'central_switch.favorite_contacts.empty',
    },
    RecentContacted: {
        text: 'central_switch.recently_contacted.empty',
    },
    FavoritePbxItems: { text: 'calls.incoming.none' },
    FavoritePbxItemsOngoingCalls: {
        text: 'Queue.QueueMembersInCall.Section.Empty',
    },
    FavoritePbxItemsIncomingCalls: {
        text: 'calls.incoming.none',
    },
    UserSchedule: {
        text: 'contact.noCalendarEvents',
    },
    MissedCallsFromQueues: {
        text: 'central_switch.missed_calls_from_queues.empty',
    },
    CoListeningAutoAlpha: {
        text: 'user_picker.no_users',
    },
};

interface Props {
    uniqueId: keyof typeof EmptyState;
}

const CentralSwitchEmptyState = ({ uniqueId }: Props) => {
    const { i18next } = useAppContext();

    return (
        <div className="px-6 text-sm text-balance text-gray-500">
            {i18next.t(EmptyState[uniqueId].text)}
        </div>
    );
};

export default CentralSwitchEmptyState;
